export const IS_DEVELOPMENT = ['development'].some(
  _ =>
    _.toLowerCase() ===
    process.env.REACT_APP_CONCUSSIONRX_DEPLOYMENT?.toLowerCase()
);
export const IS_LOCAL_ENDPOINT =
  process.env.REACT_APP_USE_FIREBASE_EMULATOR?.toLowerCase() === 'true';

/**
 * WARNING: `CRX_CONTACT_EMAIL`
 */
export const CRX_SUPPORT_EMAIL = 'support@concussionrx.com';

export const DEPLOYMENTS = {
  CRX_AGENT_BASE_PATH: process.env['REACT_APP_CRX_AGENT_BASE_PATH'] as string
} as const;
